var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateDetails',{attrs:{"get-function":_vm.getAdmin,"data":_vm.admin,"loading":_vm.adminLoading}},[_c('AdminForm',{attrs:{"title":_vm.$t('admin.edit.title'),"action":_vm.editAdmin,"model":_vm.adminFormated,"edit":true,"success-msg":_vm.$t('admin.edit.success'),"error-msg":_vm.$t('admin.edit.error')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }